import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { CmsBannerComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import * as Highcharts from 'highcharts';

@Component({
    selector: 'app-flucelvax-impactchart',
    templateUrl: './flucelvax-impactchart.component.html',
    styleUrls: ['./flucelvax-impactchart.component.scss'],
    standalone: false
})
export class FlucelvaxImpactchartComponent implements OnInit {
  referncenode: Observable<any>;
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions!: Highcharts.Options;
  chart1 = [[0, 290], [3, 380], [5, 290]];
  chart2 = [[1, 150], [2, 580], [4, 590], [6, 500], [7, 750], [8, 380], [9, 385]];
  chart4 = [[1, 150], [4, 590], [8, 380], [9, 385]];
  chart3 = [[2, 580], [6, 500], [7, 750]];

  beforeChart1 = [[0, 10], [3, 10], [5, 10]];
  beforeChart2 = [[1, 10], [2, 10], [4, 10], [6, 10], [7, 10], [8, 10], [9, 10]];
  beforeChart3 = [];
  displayLegend1 = false;
  displayLegend2 = false;
  displayLegend3 = false;
  private animationTriggered = false;
  private previousWidth: number;

  constructor(public bannerComponent: CmsComponentData<CmsBannerComponent>, private cd: ChangeDetectorRef) {
    this.referncenode = this.bannerComponent.data$;
    this.previousWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.setHighchart(this.beforeChart1, this.beforeChart2, this.beforeChart3);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.checkChart();
  }

  checkChart() {
    const chartInfo = document.getElementById('chartsubheader');
    if (chartInfo && !this.animationTriggered) {
      const anchorPosition = chartInfo.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      if (anchorPosition <= windowHeight) {
        this.animationTriggered = true; 
        this.startChartAnimation();
      }
    }
  }

  startChartAnimation() {
    setTimeout(() => {
      this.setHighchart(this.chart1, this.beforeChart2, this.beforeChart3);
      this.displayLegend1 = true;
      this.cd.detectChanges();
    }, 1000);
    setTimeout(() => {
      this.setHighchart(this.chart1, this.chart2, this.beforeChart3);
      this.displayLegend2 = true;
      this.cd.detectChanges();
    }, 2000);
    setTimeout(() => {
      this.setHighchart(this.chart1, this.chart4, this.chart3);
      this.displayLegend3 = true;
      this.cd.detectChanges();
    }, 3000);
    this.cd.detectChanges();
  }

  setHighchart(render1: number[][], render2: number[][], render3: number[][]): void {
    const yAxisLabels = [0, 200, 400, 600, 800];
    const chartType = window.innerWidth > 1023 ? 'column' : 'bar';
  
    this.chartOptions = {
      chart: {
        type: chartType
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: ['2010 - 2011', '2011 - 2012', '2012 - 2013', '2013 - 2014', '2014 - 2015', '2015 - 2016', '2016 - 2017', '2017 - 2018', '2018 - 2019', '2019 - 2020'],
        crosshair: true,
        labels: {
          useHTML: true,
          style: {
            color: 'rgba(112, 115, 114, 1)',
            fontSize: '16px',
            fontFamily: 'Campton-Book',
            fontWeight: 'normal',
            lineHeight: '24px',
            paddingLeft: '4px',
            paddingRight: '5px',
            whiteSpace: 'nowrap',
            transform: 'rotate(0deg)'
          },
          rotation: 0,
          formatter: function () {
            const value = this.value.toString();
            const parts = value.split(' - ');
            return parts.join(' -<br/>');
          }
        },
        accessibility: {
          description: 'Year'
        }
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: 'Number of Hospitalizations',
          useHTML: true,
          style: {
            color: 'var(--darkblack)',
            fontSize: '20px',
            fontFamily: 'Campton-semibold',
            fontWeight: '600',
            lineHeight: '28px',
            paddingBottom: '10px',
            transform: 'none'
          }
        },
        tickPositioner: function () {
          return yAxisLabels;
        },
        labels: {
          style: {
            color: '#707372',
            fontSize: '20px',
            fontFamily: 'Campton-semibold',
            fontWeight: '600',
            lineHeight: '26px',
            transform: 'none'
          },
          formatter: function () {
            if (typeof this.value === 'number' && this.value > 0) {
              return this.value + 'k';
            } else {
              return this.value.toString();
            }
          }
        }
      },
      tooltip: {
        valueSuffix: 'k',
        enabled: false
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          pointWidth: 30
        },
        bar: {
          pointPadding: 0.1,
          groupPadding: 0.8, // Adjust groupPadding to ensure equal gaps
          borderWidth: 0,
          pointWidth: 30 // Increase the pointWidth for bar charts
        },
        series: {
          enableMouseTracking: false
        }
      },
      series: [
        {
          type: chartType,
          name: 'Matches circulating strains',
          data: render1,
          color: {
            linearGradient: { x1: 1, x2: 1, y1: 1, y2: 0 },
            stops: [
              [0, 'rgb(9, 89, 56)'],
              [1, 'rgb(29, 137, 18)']
            ]
          },
          zIndex: 1,
          pointPlacement: 0.2
        },
        {
          type: chartType,
          name: 'A/H3N2 antigenic drift',
          data: render2,
          color: {
            linearGradient: { x1: 1, x2: 1, y1: 1, y2: 0 },
            stops: [
              [0, 'rgba(157, 160, 159, 1)'],
              [1, 'rgba(76, 76, 76, 1)']
            ]
          },
          zIndex: 0,
          pointPlacement: 0
        },
        {
          type: chartType,
          name: 'A/H3N2 egg adaptation',
          data: render3,
          color: {
            linearGradient: { x1: 1, x2: 1, y1: 1, y2: 0 },
            stops: [
              [0, 'rgba(213, 57, 10, 1)'],
              [1, 'rgba(135, 33, 2, 1)']
            ]
          },
          zIndex: 2,
          pointPlacement: -0.2
        }
      ]
    };
  }

  // @HostListener('window:resize', [])
  // onResize() {
  //   const currentWidth = window.innerWidth;
  //   if (currentWidth !== this.previousWidth) {
  //     location.reload();
  //   }
  // }
}